export default __webpack_public_path__ + "static/media/result.d6208caf.svg";